/*
 * GW Secret Offer
 * Mail-Link mit offer=<Token> schaltet das Angebot frei, auf der ersten
 * passenden PDP erscheint ein Pop-up, ein Klick setzt den Rabattcode und das
 * Warenkorb-Attribut gw_secret_offer. Liquid rendert danach die reduzierten
 * Preise, dieses Script haelt PDP und Warenkorb-Zustand synchron.
 */

(function () {
  const configEl = document.getElementById('gw-so-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }

  const now = Date.now();
  if (now < config.start || now > config.end) return;

  const CODE = String(config.code).toUpperCase();
  const STORAGE_KEY = 'gw_secret_offer';
  const SHOW_DELAY = 1500;
  const CLOSE_DELAY = 3000;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const popup = document.querySelector('[data-gw-so]');
  const pill = document.querySelector('[data-gw-so-pill]');
  const message = popup && popup.querySelector('[data-gw-so-message]');
  const offerBlock = popup && popup.querySelector('[data-gw-so-offer]');
  const replaceButton = popup && popup.querySelector('[data-gw-so-replace]');
  const keepButton = popup && popup.querySelector('[data-gw-so-keep]');

  let cartActive = String(config.cartCode || '').toUpperCase() === CODE;
  let busy = false;

  // Zustand je Code, damit ein Testcode nicht in die echte Aktion hineinwirkt
  const state = {
    get() {
      try {
        const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
        return value && value.code === CODE ? value.state : null;
      } catch (error) {
        return null;
      }
    },
    set(value) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ code: CODE, state: value, at: Date.now() }));
      } catch (error) {
        // Ohne localStorage funktioniert das Angebot nur fuer diesen Seitenaufruf
      }
    },
  };

  const track = (event, data) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event, product_handle: config.productHandle || '' }, data || {}));
  };

  const trackKlaviyo = () => {
    const properties = { code: CODE, product_handle: config.productHandle || '' };
    if (window.klaviyo && typeof window.klaviyo.track === 'function') {
      window.klaviyo.track('Secret Offer aktiviert', properties);
    } else {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Secret Offer aktiviert', properties]);
    }
  };

  const getCart = () =>
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => {
      if (!response.ok) throw new Error(`cart.js ${response.status}`);
      return response.json();
    });

  const updateCart = (body) =>
    fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => {
      if (!response.ok) throw new Error(`cart/update.js ${response.status}`);
      return response.json();
    });

  const codesOf = (cart) => (cart.discount_codes || []).map((entry) => String(entry.code));
  const ourEntry = (cart) => (cart.discount_codes || []).find((entry) => String(entry.code).toUpperCase() === CODE);

  // Codes, die gerade einen Produkt- oder Bestellrabatt geben und unseren verdraengen
  const competingCodes = (cart) => {
    const titles = new Set();
    const collect = (application) => {
      if (application && application.type === 'discount_code' && String(application.title).toUpperCase() !== CODE) {
        titles.add(String(application.title));
      }
    };
    (cart.cart_level_discount_applications || []).forEach((entry) => collect(entry.discount_application));
    (cart.items || []).forEach((item) =>
      (item.line_level_discount_allocations || []).forEach((entry) => collect(entry.discount_application))
    );
    return Array.from(titles);
  };

  // Fester Betrag je Artikel, sonst Prozent mit Rundung wie Shopify im Checkout (je Stueck abgerundet)
  const reducedPrice = (price) =>
    config.type === 'amount'
      ? price - Math.min(Number(config.amount) || 0, price)
      : price - Math.floor((price * config.percent) / 100);

  // Gleiches Format wie Liquid im Theme (money_without_currency + '€'), also 72,00€
  const moneyFormatter = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const formatMoney = (cents) => `${moneyFormatter.format(cents / 100)}€`;

  /* ---------- Preise auf der PDP ---------- */

  const applyWrapper = (wrapper) => {
    const base = Number(wrapper.dataset.gwSoBase || 0);
    const compare = Number(wrapper.dataset.gwSoCompare || 0);
    const priceEl = wrapper.querySelector('[data-product-price]');
    const compareEl = wrapper.querySelector('[data-compare-price]');
    const note = wrapper.parentElement && wrapper.parentElement.querySelector('[data-gw-so-note]');
    const active = cartActive && base > 0 && !(compare > base);

    if (note) note.hidden = !active;
    if (!active || !priceEl) return;

    priceEl.innerHTML = formatMoney(reducedPrice(base));
    priceEl.classList.add('product__price--sale', 'price--sale');
    if (compareEl) {
      compareEl.innerHTML = formatMoney(base);
      compareEl.classList.remove('hidden');
    }
  };

  const applyAll = (scope) => {
    (scope || document).querySelectorAll('[data-price-wrapper][data-gw-so-eligible]').forEach(applyWrapper);
  };

  // Das Theme schreibt die Preise bei jedem Variantenwechsel neu, danach ziehen wir nach
  document.addEventListener('theme:variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;
    const scope = event.target instanceof Element ? event.target : document;
    scope.querySelectorAll('[data-price-wrapper][data-gw-so-eligible]').forEach((wrapper) => {
      wrapper.dataset.gwSoBase = variant.price;
      wrapper.dataset.gwSoCompare = variant.compare_at_price || 0;
    });
    window.requestAnimationFrame(() => applyAll(scope));
  });

  /* ---------- Pop-up und Pille ---------- */

  const setMessage = (text) => {
    if (message) message.textContent = text || '';
  };

  const openPopup = (source) => {
    if (!popup) return;
    if (offerBlock) offerBlock.hidden = false;
    if (replaceButton) replaceButton.hidden = true;
    if (keepButton) keepButton.hidden = true;
    setMessage('');
    popup.hidden = false;
    document.documentElement.classList.add('gw-so-open');
    window.requestAnimationFrame(() => popup.classList.add('is-open'));
    if (pill) pill.hidden = true;
    track('secret_offer_view', { trigger: source });
  };

  // Erst nach dem Cookie-Banner zeigen, sonst liegen zwei Fenster uebereinander
  const consentOpen = () => {
    const banner = document.querySelector('.pd-cookie-banner-window');
    if (!banner || banner.classList.contains('cc-invisible')) return false;
    const style = window.getComputedStyle(banner);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && banner.getBoundingClientRect().height > 0;
  };

  const openWhenFree = (attempt) => {
    if (consentOpen() && attempt < 120) {
      window.setTimeout(() => openWhenFree(attempt + 1), 1000);
      return;
    }
    openPopup('auto');
  };

  const closePopup = () => {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.hidden = true;
    document.documentElement.classList.remove('gw-so-open');
  };

  const showPill = (text) => {
    if (!pill) return;
    if (text) pill.textContent = text;
    pill.hidden = false;
  };

  const dismiss = () => {
    closePopup();
    if (!cartActive) {
      state.set('dismissed');
      showPill();
    }
    track('secret_offer_dismiss');
  };

  const succeed = () => {
    cartActive = true;
    state.set('activated');
    track('secret_offer_activate', { code: CODE });
    trackKlaviyo();
    applyAll();
    document.dispatchEvent(new CustomEvent('gw:secret-offer:activated', { detail: { code: CODE } }));
    if (offerBlock) offerBlock.hidden = true;
    setMessage(config.strings.success);
    if (pill) pill.hidden = true;
    window.setTimeout(closePopup, CLOSE_DELAY);
  };

  const sendCodes = (codes) => updateCart({ discount: codes.join(','), attributes: { gw_secret_offer: CODE } });

  const setBusy = (value) => {
    busy = value;
    if (popup) popup.querySelectorAll('.gw-so__button').forEach((button) => (button.disabled = value));
  };

  const activate = async () => {
    if (busy) return;
    setBusy(true);
    setMessage('');
    try {
      const cart = await getCart();
      const others = codesOf(cart).filter((code) => code.toUpperCase() !== CODE);
      const result = await sendCodes(others.concat(CODE));
      const ours = ourEntry(result);
      const competing = competingCodes(result);

      if (ours && !ours.applicable && competing.length) {
        // Ein anderer Code verdraengt unseren: zuruecknehmen und Wahl anbieten
        await updateCart({ discount: others.join(','), attributes: { gw_secret_offer: '' } });
        if (offerBlock) offerBlock.hidden = true;
        setMessage(config.strings.conflict.replace('[codes]', competing.join(', ')));
        if (replaceButton) {
          replaceButton.querySelector('[data-gw-so-replace-text]').textContent = config.strings.conflictButton;
          replaceButton.hidden = false;
          replaceButton.dataset.drop = competing.join(',');
        }
        if (keepButton) keepButton.hidden = false;
        track('secret_offer_conflict', { blocking_code: competing.join(',') });
        return;
      }

      if (!ours) {
        // Shopify hat den Code verworfen: Rabatt-Cookie fuer den Checkout setzen
        await fetch(`${root}discount/${encodeURIComponent(CODE)}`, { credentials: 'same-origin' });
      }
      succeed();
    } catch (error) {
      setMessage(config.strings.error);
    } finally {
      setBusy(false);
    }
  };

  // Unser Code zuerst, damit er gewinnt; die verdraengenden Codes fallen weg
  const replaceCompeting = async () => {
    if (busy || !replaceButton) return;
    setBusy(true);
    try {
      const drop = (replaceButton.dataset.drop || '').toUpperCase().split(',');
      const cart = await getCart();
      const keep = codesOf(cart).filter((code) => code.toUpperCase() !== CODE && !drop.includes(code.toUpperCase()));
      await sendCodes([CODE].concat(keep));
      replaceButton.hidden = true;
      if (keepButton) keepButton.hidden = true;
      succeed();
    } catch (error) {
      setMessage(config.strings.error);
    } finally {
      setBusy(false);
    }
  };

  /* ---------- Abgleich mit dem Warenkorb ---------- */

  // Code im Drawer oder Checkout entfernt: Attribut leeren, Seite neu rendern lassen
  let syncTimer = null;
  const syncWithCart = () => {
    if (!cartActive) return;
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(async () => {
      try {
        const cart = await getCart();
        const ours = ourEntry(cart);
        // Nicht anwendbar ist nur dann ein Problem, wenn ein anderer Code unseren verdraengt
        const hasCode = Boolean(ours) && (ours.applicable || competingCodes(cart).length === 0);
        const hasAttribute = String((cart.attributes || {}).gw_secret_offer || '').toUpperCase() === CODE;
        if (hasCode && hasAttribute) return;
        cartActive = false;
        if (hasAttribute) await updateCart({ attributes: { gw_secret_offer: '' } });
        window.location.reload();
      } catch (error) {
        // Beim naechsten Seitenaufruf erneut pruefen
      }
    }, 400);
  };

  ['theme:cart:update', 'theme:cart:loaded', 'theme:cart:close'].forEach((name) =>
    document.addEventListener(name, syncWithCart)
  );

  /* ---------- Start ---------- */

  const params = new URLSearchParams(window.location.search);
  if (config.token && params.get('offer') === config.token && !state.get()) {
    state.set('unlocked');
  }

  if (popup) {
    popup.querySelectorAll('[data-gw-so-dismiss]').forEach((button) => button.addEventListener('click', dismiss));
    popup.querySelector('[data-gw-so-activate]').addEventListener('click', activate);
    if (replaceButton) replaceButton.addEventListener('click', replaceCompeting);
    if (keepButton) keepButton.addEventListener('click', dismiss);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) dismiss();
    });
  }
  if (pill) pill.addEventListener('click', () => openPopup('pill'));

  const current = state.get();

  if (cartActive) {
    applyAll();
    syncWithCart();
  } else if (current === 'unlocked' && config.eligiblePdp) {
    window.setTimeout(() => openWhenFree(0), SHOW_DELAY);
  } else if (current === 'dismissed') {
    showPill();
  } else if (current === 'activated') {
    // Nach einem Kauf ist der Warenkorb neu, das Angebot laeuft aber noch
    showPill(config.strings.reactivate);
  }
})();
